/**
 * External dependencies
 */
import { Heading } from '@art-of-hospitality-solutions-llc/ui-kit/components/heading';

/**
 * Internal dependencies
 */
import { cn } from '@Utils/cn';

type NavGroupProps = React.PropsWithChildren & {
  title?: string;
  menuExpanded?: boolean;
};

export default function NavGroup({
  children,
  title,
  menuExpanded,
}: NavGroupProps) {
  return (
    <div className="mb-3">
      {title && (
        <Heading
          level="h2"
          styleAs="h6"
          className={cn(
            'mb-3 font-bold',
            'transition-all duration-200',
            menuExpanded ? 'h-6 w-full opacity-100' : 'h-2 w-0 opacity-0',
          )}
        >
          {title}
        </Heading>
      )}
      <ul className="space-y-3">{children}</ul>
    </div>
  );
}
